import React, { useState } from "react";
import PosFeatures from "./feature.json";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { IoIosArrowDown } from "react-icons/io";
import { NavLink } from "react-router-dom";

function Features() {
  const PosSolutions = PosFeatures?.posSolutions;
  const [expanded, setExpanded] = useState("Restaurant");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : expanded);
  };

  return (
    <div>
      <div className="flex w-full flex-col items-center justify-center text-center px-4 py-5 sm:py-20 bg-gradient-to-r from-orange-50/50 orange-50 to-orange-50/50">
        <h1 className="mx-auto max-w-4xl font-display poppins_bold sm:poppins_bold tracking-normal text-white-300 text-3xl min-[400px]:text-4xl sm:text-7xl">
          Explore Our Powerful{" "}
          <span className="relative whitespace-nowrap text-orange-500">
            <svg
              aria-hidden="true"
              viewBox="0 0 418 42"
              className="absolute top-2/3 left-0 h-[0.58em] w-full fill-orange-500 dark:fill-orange-300/60"
              preserveAspectRatio="none"
            >
              <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.780 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.540-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.810 23.239-7.825 27.934-10.149 28.304-14.005 .417-4.348-3.529-6-16.878-7.066Z"></path>
            </svg>
            <span className="relative">Solution!</span>
          </span>
        </h1>
        <h2 className="min-[480px]:poppins_medium mx-auto mt-12 max-w-3xl text-lg leading-7 text-justify sm:text-center">
          Discover a suite of powerful features designed to revolutionize your
          business operations. From advanced self-service kiosks to efficient
          billing devices, our solutions ensure seamless transactions, faster
          checkouts, and enhanced customer experiences. Empower your business
          with cutting-edge technology for effortless and secure payments.
          Elevate your retail experience today!
        </h2>
      </div>
      <div className="sm:flex items-center max-w-screen-md justify-center mx-auto">
        <div className="hidden sm:block py-10 pl-10">
          <img
            alt="feature"
            src="/images/features/features_01.svg"
            className="w-96 ml-auto h-full"
          />
        </div>
        <div className="pl-5 sm:pl-0 py-5 pr-5">
          <div className="text">
            <span className="poppins_bold text-gray-500 border-b-2 border-[#f6892f] uppercase">
              Solutions
            </span>
            <h2 className="my-4 poppins_bold text-2xl min-[480px]:text-3xl sm:text-4xl">
              Solutions <span className="text-[#f6892f]">Mobi Pos</span>
            </h2>
            <p className="text-gray-700 poppins_medium text-justify">
              Welcome to MobiPOS, where we simplify business management with our
              smart point-of-sale systems. From sales and inventory to customer
              care, our solutions make it easy to run your business smoothly and
              efficiently.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-screen-md m-auto">
        <div>
          {PosSolutions.map((feature) => (
            <Accordion
              expanded={expanded === feature.id}
              onChange={handleChange(feature.id)}
            >
              <AccordionSummary
                expandIcon={<IoIosArrowDown />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                className="text-xl poppins_bold"
              >
                {feature.id}
              </AccordionSummary>
              <AccordionDetails className="text-justify">
                <div className="grid grid-cols-1 md:grid-cols-2 poppins_medium  gap-5">
                  <div>
                    {feature.description}
                    <div className="my-3 hidden md:block">
                      <NavLink
                        to={feature.url}
                        className="flex group items-center bg-[#f6892f] text-white w-fit p-2 rounded-full"
                      >
                        <span className="group-hover:mr-2 transition-all duration-300">
                          Read More
                        </span>
                        <svg
                          className="rtl:rotate-180 group-hover:-rotate-45 w-3.5 h-3.5 ms-2 transition-all duration-300"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 14 10"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 5h12m0 0L9 1m4 4L9 9"
                          />
                        </svg>
                      </NavLink>
                    </div>
                  </div>
                  <img src={feature.image} alt="feature" />
                  <div className="my-3 md:hidden block">
                    <NavLink
                      to={feature.url}
                      className="flex group items-center bg-[#f6892f] text-white w-fit p-2 rounded-full"
                    >
                      <span className="group-hover:mr-2 transition-all duration-300">
                        Read More
                      </span>
                      <svg
                        className="rtl:rotate-180 group-hover:-rotate-45 w-3.5 h-3.5 ms-2 transition-all duration-300"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 10"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M1 5h12m0 0L9 1m4 4L9 9"
                        />
                      </svg>
                    </NavLink>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>

      <div className="py-8 bg-white">
        <div className="max-w-screen-xl m-auto px-4 sm:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 gap-y-24">
            <div className="flex items-center gap-5">
              <div className="w-24 h-14 overflow-hidden">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/609/609116.png"
                  alt="dummy"
                  className="w-full object-contain"
                />
              </div>
              <div>
                <p className="font-heading text-lg leading-6 poppins_bold text-orange-400 underline-offset-2">
                  Customizable for Your Business
                </p>
                <p className="mt-2 poppins_medium text-base text-gray-500">
                  Adapt MobiPOS features to match unique needs of your business
                  model.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="w-24 h-14  overflow-hidden">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/11131/11131941.png"
                  alt="dummy"
                  className="w-full object-contain"
                />
              </div>
              <div>
                <p className="font-heading text-lg leading-6 poppins_bold text-orange-400">
                  On-the-Go Sales Tracking
                </p>
                <p className="mt-2 text-base poppins_medium text-gray-500">
                  Monitor sales performance anytime, anywhere with mobile access
                  capabilities.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="w-24 h-14  overflow-hidden">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/11683/11683412.png"
                  alt="dummy"
                  className="w-full object-contain"
                />
              </div>
              <div>
                <p className="font-heading text-lg leading-6 poppins_bold text-orange-400">
                  Secure and Reliable
                </p>
                <p className="mt-2 text-base poppins_medium text-gray-500">
                  Adapt MobiPOS features to match unique needs of your business
                  model.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="w-24 h-14  overflow-hidden">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/18294/18294518.png"
                  alt="dummy"
                  className="w-full object-contain"
                />
              </div>
              <div>
                <p className="font-heading text-lg leading-6 poppins_bold text-orange-400">
                  Seamless Integration
                </p>
                <p className="mt-2 text-base poppins_medium text-gray-500">
                  Effortlessly connect with your existing tools and payment
                  systems for a smooth workflow..
                </p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="w-24 h-14  overflow-hidden">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/12251/12251106.png"
                  alt="dummy"
                  className="w-full object-contain"
                />
              </div>
              <div>
                <p className="font-heading text-lg leading-6 poppins_bold text-orange-400">
                  Real-Time Analytics
                </p>
                <p className="mt-2 text-base poppins_medium text-gray-500">
                  Gain valuable insights with real-time reporting and
                  data-driven decision-making.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="w-24 h-14  overflow-hidden">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/18842/18842103.png"
                  alt="dummy"
                  className="w-full object-contain"
                />
              </div>
              <div>
                <p className="font-heading text-lg leading-6 poppins_bold text-orange-400">
                  Multi-Device Accessibility
                </p>
                <p className="mt-2 text-base poppins_medium text-gray-500">
                  Access and manage your business from any device, ensuring
                  flexibility and convenience..
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
